import { BaseResponse } from 'common/types/api'
import axios from 'core/api'

import { ActiveAnnouncementsResponse } from './types'

export const getActiveAnnouncements = () =>
  axios.get<BaseResponse<ActiveAnnouncementsResponse>>('/announcements/active', {
    params: { platform: 'WEB' },
  })
